<div [ngClass]="to.classes[value]">
  <ng-container #fieldComponent></ng-container>
</div>
